import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import Highcharts from "highcharts";
import App from "./App.jsx";
import "./index.css";

Highcharts.setOptions({ time: { timezone: "Europe/Zurich" } });

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ color: "#ff3355", padding: 32 }}>A critical error occurred.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
